import React from "react";
import {
  FileText,
  ClipboardCheck,
  Rocket,
  TrendingUp,
} from "lucide-react";
import { PROCESS_STEPS } from "../mock/data";

const iconMap = { FileText, ClipboardCheck, Rocket, TrendingUp };

const HowItWorks = () => {
  return (
    <section id="process" className="relative py-24 lg:py-32 bg-[#0E0E13] overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-40" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[200px] rounded-full bg-[#14E0BF]/8 blur-[120px]" />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-16 lg:mb-24 max-w-[820px] mx-auto">
          <div className="inline-flex items-center gap-2 mb-6">
            <Rocket className="w-4 h-4 text-[#14E0BF]" />
            <span className="font-mono text-[11px] text-[#14E0BF] uppercase tracking-[0.2em]">
              The Launch Path
            </span>
          </div>
          <h2 className="text-white">
            <span className="font-display text-5xl lg:text-7xl leading-[0.95] block">
              FROM APPLY
            </span>
            <span className="font-serif-display italic text-5xl lg:text-7xl leading-[0.95] block mt-1">
              to live orders in <span className="text-[#14E0BF]">14 days</span>.
            </span>
          </h2>
          <p className="mt-6 text-white/65 text-base lg:text-lg max-w-[640px] mx-auto">
            No bureaucracy. No 12-month franchise discovery process. Four steps, fully supported, with humans on the other end.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line on desktop */}
          <div className="hidden lg:block absolute left-1/2 top-12 bottom-12 w-px bg-gradient-to-b from-transparent via-[#14E0BF]/30 to-transparent" />

          <div className="space-y-10 lg:space-y-20">
            {PROCESS_STEPS.map((step, i) => {
              const Icon = iconMap[step.icon];
              const isLeft = i % 2 === 0;
              return (
                <div
                  key={step.id}
                  className={`grid lg:grid-cols-2 gap-6 lg:gap-16 items-center ${
                    isLeft ? "" : "lg:[&>*:first-child]:order-2"
                  }`}
                >
                  {/* Number / icon side */}
                  <div className={`flex ${isLeft ? "lg:justify-end" : "lg:justify-start"}`}>
                    <div className="relative">
                      <div className="font-serif-display italic text-[180px] lg:text-[240px] leading-[0.85] text-white/8">
                        {step.id}
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-24 h-24 lg:w-28 lg:h-28 rounded-2xl bg-[#14E0BF] flex items-center justify-center teal-glow-strong">
                          <Icon className="w-10 h-10 lg:w-12 lg:h-12 text-[#07070A]" strokeWidth={2} />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Text side */}
                  <div className={`${isLeft ? "lg:pl-8" : "lg:pr-8"}`}>
                    <div className="flex items-center gap-3 mb-4">
                      <span className="font-mono text-[11px] text-[#F77F00] uppercase tracking-[0.18em]">
                        Step {step.id}
                      </span>
                      <span className="h-px w-10 bg-white/20" />
                      <span className="font-mono text-[11px] text-white/50 uppercase tracking-wider">
                        {step.duration}
                      </span>
                    </div>
                    <h3 className="font-display text-white text-3xl lg:text-5xl uppercase leading-[1] mb-4">
                      {step.title}
                    </h3>
                    <p className="text-white/70 text-base lg:text-lg leading-relaxed max-w-[480px]">
                      {step.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
